import styled, { css } from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledNameContainer = styled.div`
	margin-top: 20px;
	text-align: center;
	transition: opacity 0.3s ease;

	${Text} {
		font-weight: 400;
		font-size: 18px;

		span {
			opacity: 0.5;
		}
	}
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	margin-top: 30px;

	${Text} {
		font-size: 16px;
		font-weight: 400;
	}
`;

const StyledContainer = styled.div<{
	$selected?: boolean;
	$notActive?: boolean;
}>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 200px;
	height: 200px;
	border-radius: 10px;
	transition:
		background 0.3s ease,
		border 0.3s ease;
	user-select: none;

	img {
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
		pointer-events: none;
	}

	${Text} {
		color: #ffffff;
		transition: color 0.3s ease;
	}

	${(props) =>
		props.$selected
			? css`
					background: #2d70da;
			  `
			: css`
					background: rgba(255, 255, 255, 0.05);
					border: 1px solid rgba(255, 255, 255, 0.1);
			  `}

	${(props) =>
		props.$notActive
			? css`
					background: rgba(255, 255, 255, 0.02);
					border: 1px solid rgba(255, 255, 255, 0.05);

					${StyledNameContainer} {
						opacity: 0.25;
					}

					img {
						opacity: 0.25;
					}
			  `
			: css`
					cursor: pointer;
			  `}



  ${(props) =>
		!props.$notActive &&
		!props.$selected &&
		css`
			&:hover {
				background-color: #ffffff;

				img {
					filter: invert(100%);
				}

				${Text} {
					color: #000000;
				}
			}
		`}
`;

export { StyledContainer, StyledNameContainer, StyledPriceContainer };
